import httpService from 'services/httpService'

const BASE_URL = 'https://www.cultivointeligente.com.br'

export const getTerm = async (params) => {
  return await httpService.get(BASE_URL + '/api/v4/terms/get_term', { params })
}
